let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("agAjs")).then(() => parcelRequire('h8GF6'));